import { createReducer, on } from '@ngrx/store';

import { selectTravelExtraInputAction } from '@shared/base-search-bar/store/actions/search-bar.actions';
import { loadSearchDataSuccessAction } from '@shared/base-search-bar/store/actions/storage.actions';
import { InputTravelExtra } from '@shared/base-search-bar/entities/autocomplete-travel-extra';

export const initialState: InputTravelExtra = {} as InputTravelExtra;

export const travelExtraInputReducer = createReducer(
  initialState,
  on(selectTravelExtraInputAction, (state, { selection }) => {
    return selection;
  }),
  on(loadSearchDataSuccessAction, (state, { data }) => data?.inputTravelExtra ?? initialState),
);
